import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import React, { useEffect, useState } from "react";

import ResetPasswordForm from "./ResetPasswordForm";
import {
  SuccessAlert,
  AsyncCallArgs,
  CardSpg,
  ErrorAlert,
  useAsyncCall,
  useKeycloak,
} from "@duosoftbg/nacid-components";
import { Button, CardContent } from "@mui/material";
import { resetPasswordValidation } from "../../../../../../axios/api/services";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { TemporaryKeyStatusType } from "../../../../../../constants/temporaryKeyStatusType";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";

const renderResetPasswordView = (isKeyValidated, status, updatedUser, setStatus, setUpdatedUser, keycloak, t) => {
  if (isKeyValidated) {
    const handleLogin = () => {
      keycloak.login({ redirectUri: ProcessEnvironments.Module.FrontOffice.Portal });
    };

    switch (status) {
      case TemporaryKeyStatusType.KEY_NOT_FOUND:
        return <ErrorAlert message={"m.reset.password.key.invalid"} />;
      case TemporaryKeyStatusType.USER_NOT_FOUND:
        return <ErrorAlert message={"m.reset.password.user.invalid"} />;
      case TemporaryKeyStatusType.EXPIRED_KEY:
        return <ErrorAlert message={"m.reset.password.key.expired"} />;
      case TemporaryKeyStatusType.USED_KEY:
        return <ErrorAlert message={"m.reset.password.key.used"} />;
      case TemporaryKeyStatusType.EXCEPTION:
        return <ErrorAlert message={"m.reset.password.key.error"} />;
      case TemporaryKeyStatusType.SUCCESS:
        return (
          <div>
            <SuccessAlert message={"m.reset.password.success"} dynamicValuesObject={{ user: updatedUser }} />
            {keycloak && (
              <div style={{ marginTop: 10 }}>
                <Button
                  style={{ minWidth: 120 }}
                  onClick={handleLogin}
                  size={"medium"}
                  type={"button"}
                  variant="contained"
                  color="primary"
                >
                  {t("m.portalLogin")}
                </Button>
              </div>
            )}
          </div>
        );
      default:
        return <ResetPasswordForm statusUpdate={setStatus} userUpdate={setUpdatedUser} />;
    }
  }

  return null;
};

const ResetPassword = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [searchParams] = useSearchParams();
  const [isKeyValidated, setIsKeyValidated] = useState(false);
  const [updatedUser, setUpdatedUser] = useState(null);
  const [status, setStatus] = useState(null);
  const { initialized, keycloak } = useKeycloak();

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: resetPasswordValidation(searchParams.get("key")),
      onSuccess: (response) => {
        setStatus(response);
        setIsKeyValidated(true);
      },
      onError: () => {
        setStatus(TemporaryKeyStatusType.EXCEPTION);
      },
    };
    asyncCall(asyncCallArgs);

    // eslint-disable-next-line
  }, []);

  return (
    <PageWrapper title={t("t.page.reset.password")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          {renderResetPasswordView(isKeyValidated, status, updatedUser, setStatus, setUpdatedUser, keycloak, t)}
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default ResetPassword;
